import { AxiosError } from "axios";
import { deleteApi, getApi, patchApi, postApi } from "../CreateApi";
import { BodyPostCampus, ResponseGetCampus, ResponseIdCampus } from "./interfaceCampusDetail";



export const getCampus = async (): Promise<ResponseGetCampus[]> => {
    try {
        const data = await getApi('/campus-detail');
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetCampus[];
    }
}



export const postCampus = async (body: BodyPostCampus): Promise<ResponseGetCampus> => {
    try {
        const data = await postApi('/campus-detail', body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetCampus;
    }
}


export const getCampusId = async (term?: number): Promise<ResponseIdCampus> => {
    try {
        const data = await getApi(`/campus-detail/${term}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseIdCampus;
    }
}


export const deleteCampus = async (term: number): Promise<any> => {
    try {
        const data = await deleteApi(`/campus-detail/${term}`, term);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const patchCampus = async (body: BodyPostCampus, id?:number): Promise<ResponseGetCampus> => {

    try {
        const data = await patchApi(`/campus-detail/${id}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetCampus;
    }
}
